import {initI18n} from '@eitje/i18n'
import {ENV} from './environment'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from '../data/locales/en/en.json'
import nl from '../data/locales/nl/nl.json'

const resources = {
	en: {
		translation: en,
	},
	nl: {
		translation: nl,
	},
}

export const {i18n, languages, t, mdT, parseT, getLanguage, changeLanguage} = initI18n({
	resources,
	env: ENV,
	middlewareFn: i18n => i18n.use(LanguageDetector),
})

export default i18n
